import ActorTutorialCompletedPage from './ActorTutorialCompletedPage';

export default ActorTutorialCompletedPage;
